import HistoryType from "@/domain/HistoryType";

export const Created = new HistoryType(0, "Создано")
export const PrintPacked = new HistoryType(1, "Распечатано")
export const PostPacked = new HistoryType(2, "Сформировано")
export const RemoveFromPostPackage = new HistoryType(3, "Досыл")
export const Performed = new HistoryType(4, "Результат установлен")
export const RemoveFromPostPackageAsErrorEntered = new HistoryType(5, "Удален из пост-пакета, добавлен был ошибочно")
export const DistributedToPostOffice = new HistoryType(6, "Распределен на почтовое отделение")
export const TransferInformedToExternalClient = new HistoryType(7, "Передача информирована в Шипокс")
export const TransferCompleted = new HistoryType(8, "Передача завершена")
